import { apiPaths } from "@/lib/api/paths";
import { apiClient } from "@/lib/api/client";
import type { CreateUserDTO, CreateUserResponse } from "./type";

export async function createUser(
  user: CreateUserDTO,
): Promise<CreateUserResponse> {
  const response = await apiClient.post<CreateUserResponse>(
    apiPaths.users.create,
    user,
  );
  return response.data;
}
